import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 4px;\n  border: none;\n  flex-grow: 1;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: transparent !important; // to re-set all browsers pseudo-styles\n  filter: none !important; // to re-set all browsers pseudo-styles\n  color: ", ";\n  padding: 0 ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  \n  ", "\n  ", "\n  \n  &:active, &:focus {\n    outline: none;\n  }\n  ::placeholder {\n    -webkit-text-fill-color: ", ";\n    color: ", ";\n    font-weight: 400;\n    opacity: 1; // Firefox workaround\n  }\n  ::-ms-clear {\n    display: none;\n  }\n  ::-ms-reveal {\n    display: none;\n  }\n  ::-ms-value {\n    background-color: transparent;\n  }\n\n  transition: background-color 99999s, color 0.2s ease-out, filter 99999s;\n  &:-webkit-autofill {\n    transition: background-color 99999s, color 99999s, filter 99999s;\n    animation-name: ", ";\n  }\n  &:not(:-webkit-autofill) {\n    animation-name: ", ";\n  }\n\n  &:invalid {\n    box-shadow: none; // Firefox workaround\n  }\n\n  ", "\n  ", "\n  ", "\n  \n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { INACTIVE_GRAY, NIGHTINGALE_BLACK } from '../../colors';
import { getPx } from '../../helpers/common';
import { INPUT_HEIGHT, INPUT_HORIZONTAL_PADDING, INPUT_TEXT_WITH_ICON_LEFT_PADDING, INPUT_VERTICAL_PADDING } from '../../Input/constants';
import { onAutoFillCancel, onAutoFillStart } from '../../hooks/useAutofill';
import { Input as InputSize } from '../../Typography/constants/input.size';
import { baseTextStyle } from '../../Typography/style/base';
import { isDefined } from '../../helpers/defined';
import { baseHighlightStyle } from '../../tokens/highlight';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
import { paddingLeft } from '../../style/padding-left';
import { paddingRight } from '../../style/padding-right';
import { height, paddingVertical } from '../../style';
var FormField = styled.div(_templateObject(), NIGHTINGALE_BLACK, getPx(INPUT_HORIZONTAL_PADDING), fontSize(InputSize.fontSize), lineHeight(InputSize.lineHeight), baseTextStyle, baseHighlightStyle, function (_ref) {
  var $withIcon = _ref.$withIcon;
  return $withIcon ? paddingLeft(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : '';
}, function (_ref2) {
  var $withRightIcon = _ref2.$withRightIcon;
  return $withRightIcon ? paddingRight(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : '';
}, function (_ref3) {
  var $resize = _ref3.$resize;
  return isDefined($resize) ? "resize: " + $resize + ";" : '';
}, function (_ref4) {
  var multiple = _ref4.multiple,
      $multiline = _ref4.$multiline;
  return !multiple && !$multiline ? height(INPUT_HEIGHT) : '';
}, paddingVertical(INPUT_VERTICAL_PADDING), INACTIVE_GRAY, INACTIVE_GRAY, onAutoFillStart, onAutoFillCancel, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? "\n        opacity: 1; // iOS workaround\n        -webkit-text-fill-color: " + INACTIVE_GRAY + ";\n        color: " + INACTIVE_GRAY + ";\n        cursor: not-allowed;\n        pointer-events: all;\n      " : '';
}, function (_ref6) {
  var $withPrefix = _ref6.$withPrefix;
  return $withPrefix ? "\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      " : '';
}, function (_ref7) {
  var $withSuffix = _ref7.$withSuffix;
  return $withSuffix ? "\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      " : '';
}, function (_ref8) {
  var $truncateValue = _ref8.$truncateValue;
  return $truncateValue && "\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  ";
});
export default FormField;